import { useState, useEffect } from 'react'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { useNotify } from 'react-admin'
import { validateExpirationDate } from '../validators/DateValidators'

const GlobalExpirationSetting = () => {
  const [open, setOpen] = useState(false)
  const [savedExpirationDate, setSavedExpirationDate] = useState('')
  const [tempExpirationDate, setTempExpirationDate] = useState('')
  const [error, setError] = useState(null)
  const notify = useNotify()

  useEffect(() => {
    const storedDate = localStorage.getItem('mfh-lot-expiration')
    if (storedDate) {
      setSavedExpirationDate(storedDate)
    }
  }, [])

  const handleClickOpen = () => {
    setTempExpirationDate(savedExpirationDate)
    setError(null)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = () => {
    const errorMsg = validateExpirationDate({ required: true })(tempExpirationDate)
    if (errorMsg) {
      setError(errorMsg)
      return
    }

    localStorage.setItem('mfh-lot-expiration', tempExpirationDate)
    setSavedExpirationDate(tempExpirationDate)
    setOpen(false)
    notify('Global Lot Expiration updated', { type: 'success' })
  }

  const handleInputChange = (e) => {
    setTempExpirationDate(e.target.value)
    if (error) setError(null)
  }

  return (
    <>
      <Button color="inherit" onClick={handleClickOpen} startIcon={<CalendarTodayIcon />}>
        Lot Exp: {savedExpirationDate || 'Not Set'}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Set Global Lot Expiration</DialogTitle>
        <DialogContent>
          <p>
            Enter the expiration date for the current lot of kits. This value will be used when assigning new kits to orders.
          </p>
          <TextField
            autoFocus
            margin="dense"
            id="expirationDate"
            label="Expiration Date (MM/DD/YYYY)"
            type="text"
            fullWidth
            variant="standard"
            value={tempExpirationDate}
            onChange={handleInputChange}
            placeholder="MM/DD/YYYY"
            error={!!error}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default GlobalExpirationSetting
